<template>
  <div class="student-note-page">
    <PageSpinner :onloader="onloader" />
    <div class="container-fluid student-note-page__container">
      <div class="student-note-page__header">
        <div>
          <span class="student-note-page__eyebrow">STUDENT RECORDS</span>
          <h2>Student notes</h2>
          <p>Record and review important information for this student.</p>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-5 mb-4">
          <section class="note-form-card">
            <header class="note-form-card__header">
              <div class="note-form-card__icon">
                <i class="fa fa-pencil" aria-hidden="true"></i>
              </div>
              <div>
                <span class="note-form-card__eyebrow">{{ process === "U" ? "UPDATE RECORD" : "NEW RECORD" }}</span>
                <h3>{{ process === "U" ? "Edit note" : "Add a note" }}</h3>
              </div>
            </header>

            <div v-if="studentitems" class="student-context">
              <img
                :src="studentitems.Passport || '/img/brand/loguser.png'"
                class="student-context__avatar"
                alt=""
              />
              <div class="student-context__details">
                <strong>{{ studentitems.StudentName }}</strong>
                <span>{{ studentitems.AdmNo }}</span>
                <small>
                  {{ studentitems.Sch_Class }}
                  <span v-if="studentitems.ClassOption">· {{ studentitems.ClassOption }}</span>
                  <span v-if="studentitems.SectionName">· {{ studentitems.SectionName }}</span>
                </small>
              </div>
            </div>

            <form class="note-form" @submit.prevent="submitdata">
              <div class="form-group">
                <label for="NoteHeadingval">Note heading</label>
                <vue-editor
                  id="NoteHeadingval"
                  v-model="NoteHeadingval"
                  :editorToolbar="headingToolbar"
                ></vue-editor>
              </div>
              <div class="form-group mb-0">
                <label for="NoteBodyval">Note details</label>
                <vue-editor id="NoteBodyval" v-model="NoteBodyval"></vue-editor>
              </div>

              <div class="note-form__actions">
                <button
                  v-if="process === 'U'"
                  class="btn btn-outline-secondary"
                  type="button"
                  :disabled="isSubmittingNote"
                  @click="cancelEdit"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  class="btn btn-primary note-form__submit"
                  :disabled="isSubmittingNote"
                >
                  <i
                    :class="isSubmittingNote ? 'fa fa-spinner fa-spin mr-2' : 'fa fa-check mr-2'"
                    aria-hidden="true"
                  ></i>
                  {{ isSubmittingNote ? "Saving..." : process === "U" ? "Save changes" : "Save note" }}
                </button>
              </div>
            </form>
          </section>
        </div>

        <div class="col-lg-7 mb-4">
          <section class="note-history-panel">
              <div class="note-history">
                <div class="note-history__header">
                  <div>
                    <span class="note-history__eyebrow">STUDENT RECORD</span>
                    <h3 class="mb-0">Note history</h3>
                  </div>
                  <span
                    v-if="noteonstudentitem && noteonstudentitem.length"
                    class="note-history__count"
                  >
                    {{ noteonstudentitem.length }}
                    {{ noteonstudentitem.length === 1 ? "note" : "notes" }}
                  </span>
                </div>

                <div
                  v-if="!noteonstudentitem || noteonstudentitem.length === 0"
                  class="note-history__empty"
                >
                  <i class="fa fa-sticky-note-o" aria-hidden="true"></i>
                  <h4>No notes recorded</h4>
                  <p class="mb-0">Saved notes for this student will appear here.</p>
                </div>

                <div v-else class="note-history__list">
                  <article
                    v-for="item in noteonstudentitem"
                    :key="item.Id"
                    class="note-card"
                  >
                    <div class="note-card__top">
                      <span class="note-card__date">
                        <i class="fa fa-calendar-o mr-1" aria-hidden="true"></i>
                        {{ formatDateOnly(item.DateCreated) }}
                      </span>
                      <button
                        class="btn btn-outline-secondary btn-sm note-card__edit"
                        type="button"
                        @click="edititem(item)"
                      >
                        <i class="fa fa-edit mr-1" aria-hidden="true"></i>Edit
                      </button>
                    </div>
                    <div class="note-card__content">
                      <div
                        class="note-card__heading"
                        v-html="item.Noteheading"
                      ></div>
                      <div class="note-card__body" v-html="item.Notebody"></div>
                    </div>
                  </article>
                </div>
              </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateFormaterMixin from "@/mixins/DateFormater.mixin";
import "quill/dist/quill.snow.css";
import { VueEditor } from "vue2-quill-editor";
import Alert from "@/mixins/Alert.mixins";
import PageSpinner from "@/components/PageSpinner";
import CheckStaffUser from "@/mixins/CheckStaffUser.mixin";
import katex from "katex";
import "katex/dist/katex.min.css";
window.katex = katex;
export default {
  name: "studentnote",
  mixins: [CheckStaffUser, Alert, DateFormaterMixin],
  components: {
    PageSpinner,
    VueEditor,
  },
  props: {
    studentId: {
      type: [String, Number],
      default: null,
    },
    studentDetails: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      accessDetails: null,
      dataid: 1,
      StudIdval: localStorage.getItem("StudentId"),
      NoteHeadingval: "",
      NoteBodyval: "",
      studentitems: null,
      noteonstudentitem: null,
      process: "N",
      onloader: "none",
      isSubmittingNote: false,
      headingToolbar: [
        ["bold", "italic", "underline"],
        [{ color: [] }],
        ["clean"],
      ],
    };
  },
  computed: {
    StudentIdVal() {
      if (this.studentId !== null && this.studentId !== undefined) {
        return this.studentId;
      }
      return this.StudIdval || localStorage.getItem("StudentId");
    },
  },
  watch: {
    StudentIdVal: {
      immediate: true,
      handler(value) {
        if (!value) return;
        this.getnoteonstudent();
      },
    },
    studentDetails(value) {
      if (value) this.studentitems = value;
    },
  },
  methods: {
    edititem(item) {
      if (!item) return;

      this.dataid = item.Id;
      this.process = "U";
      this.NoteHeadingval = item.Noteheading || "";
      this.NoteBodyval = item.Notebody || "";
    },
    cancelEdit() {
      this.process = "N";
      this.dataid = 1;
      this.NoteHeadingval = "";
      this.NoteBodyval = "";
    },
    async submitdata() {
      if (this.isSubmittingNote) return;
      if (!this.StudentIdVal) {
        this.ShowAlertError("No student selected.", "");
        return;
      }

      const userdata = {
        Id: this.dataid,
        NoteHeading: this.NoteHeadingval,
        NoteBody: this.NoteBodyval,
        StudId: this.StudentIdVal,
        processop: this.process,
        username: this.$store.state.auth.username,
        accesskey: this.$store.state.auth.accesskey,
      };
      this.isSubmittingNote = true;
      this.onloader = "flex";
      try {
        const resp = await this.$store.dispatch(
          "processnoteonstudent",
          userdata
        );
        if (resp && resp.responseCode && resp.responseCode !== "00") {
          this.ShowAlertError(
            resp.responseMessage || "The note could not be saved.",
            ""
          );
          return;
        }

        const updatedItems = Array.isArray(resp)
          ? resp
          : resp && Array.isArray(resp.data)
          ? resp.data
          : null;
        if (updatedItems) {
          this.noteonstudentitem = this.sortByDateCreated(updatedItems);
        } else {
          await this.getnoteonstudent();
        }

        this.process = "N";
        this.dataid = 1;
        this.NoteBodyval = "";
        this.NoteHeadingval = "";
        this.ShowAlertSuccess("Submitted Successfully", "");
      } catch (err) {
        const responseData = err && err.response && err.response.data;
        const message =
          (typeof responseData === "string" && responseData) ||
          (responseData &&
            (responseData.message || responseData.responseMessage)) ||
          (err && err.message) ||
          "The note could not be saved.";
        this.ShowAlertError(message, "");
      } finally {
        this.onloader = "none";
        this.isSubmittingNote = false;
      }
    },
    async getnoteonstudent() {
      if (!this.StudentIdVal) return [];
      this.onloader = "flex";
      try {
        const resp = await this.$store.dispatch(
          "getnoteonstudent",
          this.StudentIdVal
        );
        this.noteonstudentitem = this.sortByDateCreated(
          Array.isArray(resp) ? resp : []
        );
        return this.noteonstudentitem;
      } catch (err) {
        const responseData = err && err.response && err.response.data;
        this.ShowAlertError(
          (typeof responseData === "string" && responseData) ||
            (responseData &&
              (responseData.message || responseData.responseMessage)) ||
            (err && err.message) ||
            "Could not load student notes.",
          ""
        );
        return [];
      } finally {
        this.onloader = "none";
      }
    },
  },
  mounted() {
    this.accessDetails = this.$store.getters["auth/_user"];
    if (this.accessDetails.isSchoolStaff == false) {
      this.$store.dispatch("auth/Logout");
      this.$router.push("/login");
    } else {
      if (this.studentDetails) this.studentitems = this.studentDetails;
    }
  },
};
</script>

<style scoped>
.student-note-page {
  min-height: 100%;
  background: #f6f8fb;
}

.student-note-page__container {
  padding-top: 1.75rem;
  padding-bottom: 2rem;
}

.student-note-page__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
}

.student-note-page__eyebrow,
.note-form-card__eyebrow {
  display: block;
  margin-bottom: 0.35rem;
  color: #83909e;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.1em;
}

.student-note-page__header h2 {
  margin: 0;
  color: #263b55;
  font-size: 1.6rem;
  font-weight: 700;
}

.student-note-page__header p {
  margin: 0.35rem 0 0;
  color: #7b8998;
  font-size: 0.9rem;
}

.note-form-card,
.note-history-panel {
  height: 100%;
  border: 1px solid #e5eaf0;
  border-radius: 0.9rem;
  background: #fff;
  box-shadow: 0 0.4rem 1.25rem rgba(50, 70, 90, 0.06);
}

.note-form-card {
  padding: 1.25rem;
}

.note-form-card__header {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding-bottom: 1.1rem;
  border-bottom: 1px solid #edf0f3;
}

.note-form-card__icon {
  display: grid;
  flex: 0 0 2.5rem;
  width: 2.5rem;
  height: 2.5rem;
  place-items: center;
  border-radius: 0.7rem;
  background: #eaf2ff;
  color: #2874c8;
}

.note-form-card__eyebrow {
  margin-bottom: 0.15rem;
  font-size: 0.62rem;
}

.note-form-card__header h3 {
  margin: 0;
  color: #344767;
  font-size: 1.05rem;
  font-weight: 700;
}

.student-context {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  min-width: 0;
  margin: 1rem 0 1.25rem;
  padding: 0.8rem;
  border: 1px solid #e8edf3;
  border-radius: 0.7rem;
  background: #f8fafc;
}

.student-context__avatar {
  flex: 0 0 3rem;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  object-fit: cover;
  background: #e9edf2;
}

.student-context__details {
  display: grid;
  min-width: 0;
  gap: 0.12rem;
}

.student-context__details strong {
  overflow: hidden;
  color: #344767;
  font-size: 0.88rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.student-context__details span,
.student-context__details small {
  color: #7b8998;
  font-size: 0.74rem;
}

.note-form .form-group {
  margin-bottom: 1.2rem;
}

.note-form label {
  margin-bottom: 0.45rem;
  color: #44566c;
  font-size: 0.8rem;
  font-weight: 700;
}

.note-form__actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.6rem;
  margin-top: 1.25rem;
  padding-top: 1rem;
  border-top: 1px solid #edf0f3;
}

.note-form__actions .btn {
  margin: 0;
  border-radius: 0.5rem;
  font-size: 0.8rem;
  font-weight: 600;
}

.note-form__submit {
  min-width: 130px;
}

.note-history-panel {
  padding: 1.25rem;
}

.note-history {
  height: 100%;
}

.note-history__header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1rem;
  margin: 0.5rem 0 1.25rem;
}

.note-history__eyebrow {
  display: block;
  margin-bottom: 0.3rem;
  color: #83909e;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.1em;
}

.note-history__header h3 {
  color: #344767;
  font-size: 1.25rem;
  font-weight: 700;
}

.note-history__count {
  padding: 0.35rem 0.7rem;
  border-radius: 999px;
  background: #edf2f7;
  color: #526273;
  font-size: 0.75rem;
  font-weight: 700;
  white-space: nowrap;
}

.note-history__list {
  display: grid;
  gap: 1rem;
}

.note-card {
  min-width: 0;
  overflow: hidden;
  border: 1px solid #e5eaf0;
  border-radius: 0.75rem;
  background: #fff;
  box-shadow: 0 0.25rem 0.75rem rgba(50, 70, 90, 0.06);
}

.note-card__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.85rem 1rem;
  border-bottom: 1px solid #edf0f3;
  background: #fafbfd;
}

.note-card__date {
  color: #66778a;
  font-size: 0.78rem;
  font-weight: 600;
}

.note-card__edit {
  flex: 0 0 auto;
  margin: 0;
}

.note-card__content {
  padding: 1rem;
  color: #526273;
  overflow-wrap: anywhere;
}

.note-card__heading {
  margin-bottom: 0.55rem;
  color: #344767;
  font-size: 1rem;
  font-weight: 700;
}

.note-card__heading ::v-deep p,
.note-card__body ::v-deep p {
  margin-bottom: 0.5rem;
}

.note-card__body {
  color: #66778a;
  font-size: 0.9rem;
  line-height: 1.6;
}

.note-card__heading ::v-deep img,
.note-card__body ::v-deep img {
  max-width: 100%;
  height: auto;
}

.note-card__heading ::v-deep table,
.note-card__body ::v-deep table {
  max-width: 100%;
}

.note-history__empty {
  padding: 2.5rem 1rem;
  border: 1px dashed #d9e1e8;
  border-radius: 0.75rem;
  color: #83909e;
  text-align: center;
}

.note-history__empty i {
  margin-bottom: 0.75rem;
  color: #aab6c2;
  font-size: 1.75rem;
}

.note-history__empty h4 {
  margin-bottom: 0.35rem;
  color: #526273;
  font-size: 1rem;
  font-weight: 700;
}

@media (max-width: 575.98px) {
  .student-note-page__container {
    padding: 1rem 0.75rem;
  }

  .student-note-page__header h2 {
    font-size: 1.35rem;
  }

  .note-form-card,
  .note-history-panel {
    padding: 1rem;
  }

  .note-history__header h3 {
    font-size: 1.1rem;
  }

  .note-card__top,
  .note-card__content {
    padding: 0.75rem;
  }

  .note-form__actions {
    flex-direction: column-reverse;
  }

  .note-form__actions .btn {
    width: 100%;
  }
}
</style>
